module.exports = __webpack_public_path__ + "img/shehui-banner.e4f9b7d6.jpg";